<template>
    <div id="NuclearIndustryRobot">
    <view1/>
    <view2/>
    <view3/>
    <view4/>
    <view5/>
    <view6/>
    </div>

</template>
<script>
    export default {
        name: 'NuclearIndustryRobot',
        components: {
        view1: () => import('@/views/NuclearIndustryRobot/view1.vue'),
        view2: () => import('@/views/NuclearIndustryRobot/view2.vue'),
        view3: () => import('@/views/NuclearIndustryRobot/view3.vue'),
        view4: () => import('@/views/NuclearIndustryRobot/view4.vue'),
        view5: () => import('@/views/NuclearIndustryRobot/view5.vue'),
        view6: () => import('@/views/NuclearIndustryRobot/view6.vue')
        }
    }
</script>
<style scoped>
</style>